import React, { FC } from 'react';
import { Status } from '../../../types/tecton_proto/servergroupservice/server_group_service';
import { Badge } from '@lithos';
import { BadgeColor } from '@lithos/Badge';

const ServerGroupStatusBadge: FC<{ status: Status }> = ({ status }) => {
  const StatusToColor: Record<Status, { label: string; color: BadgeColor }> = {
    [Status.UNSPECIFIED]: { color: 'gray', label: 'Unspecified' },
    [Status.READY]: { color: 'green', label: 'Ready' },
    [Status.PENDING]: { color: 'blue', label: 'Pending' },
    [Status.CREATING]: { color: 'blue', label: 'Creating' },
    [Status.UPDATING]: { color: 'purple', label: 'Updating' },
    [Status.DELETING]: { color: 'yellow', label: 'Deleting' },
    [Status.ERROR]: { color: 'red', label: 'Error' },
  };
  return <Badge label={StatusToColor[status].label} color={StatusToColor[status].color} size="s" />;
};

export default ServerGroupStatusBadge;
